import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { themeColor } from '../../Theming';
import colors from '../../Theming/colors';
import itvColors from '../../Theming/ITVTheme/colors';
import { Helmet } from 'react-helmet';
import itvIcon from '../../Assets/Branding/itv_logo.png';
import images from '../../Theming/images';

const Container = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  background-color: ${itvColors.greenishBlue};
`;

const Body = styled.div<{ bodyMarginTop?: number }>`
  background-color: ${themeColor('white')};
  margin-top: ${(props) => (props.bodyMarginTop ? props.bodyMarginTop : -3)}px;
  min-height: 400px;
  padding-top: 1px;
`;

const Header = styled.div`
  height: 245px;

  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
`;

const HeaderText = styled.div`
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  color: ${colors.white};
  width: 250px;
  padding-top: 24px;
`;

const BoldText = styled.div`
  font-weight: bold;
`;

const StyledBrandedIcon = styled.img`
  width: 60px;
  height: 60px;
`;
interface MultiStepContainerProps extends PropsWithChildren {
  headerText?: string;
  headerTextWidth?: number;
  bodyMarginTop?: number;
}

const MultiStepActivationContainer: React.FC<MultiStepContainerProps> = ({
  children,
  headerText,
  bodyMarginTop,
}) => {
  const { t } = useTranslation();

  return (
    <Container id="activationContainer">
      <Helmet>
        <link rel="icon" type="image/png" sizes="16x16" href={itvIcon} />
        <title>ITV Cash Saver</title>
      </Helmet>
      <Header id="activationHeader">
        <StyledBrandedIcon
          id="activationHeaderImage"
          src={images.itv_logo}
          alt=" icon"
        />
        <HeaderText id="activationHeaderText">
          <Trans t={t} i18nKey={headerText}>
            <BoldText>AbsoluteText</BoldText>
          </Trans>
        </HeaderText>
      </Header>
      <Body bodyMarginTop={bodyMarginTop}>{children}</Body>
    </Container>
  );
};

export default MultiStepActivationContainer;
